import { useParams } from 'react-router-dom';
import { CategoryGrid } from '@/components/blog/CategoryGrid';
import { PostList } from '@/components/blog/PostList';
import { Seo } from '@/components/seo/Seo';
import { Container } from '@/components/ui/Container';
import { usePostsByCategory, useCategories } from '@/hooks/usePosts';

export const CategoriesPage = (): React.JSX.Element => {
  const { category } = useParams();
  const { posts, isLoading } = usePostsByCategory(category ?? '');
  const { categories } = useCategories();

  if (category) {
    return (
      <>
        <Seo title={`Category: ${category}`} description={`Posts filed under ${category}.`} path={`/categories/${category}`} />
        <Container>
          <section className="section-stack">
            <div className="section-heading">
              <h1>{category}</h1>
              {!isLoading && <p>{posts.length} post(s)</p>}
            </div>
            {!isLoading && <PostList posts={posts} />}
          </section>
        </Container>
      </>
    );
  }

  return (
    <>
      <Seo title="Categories" description="Browse categories on the PublishWeaver blog." path="/categories" />
      <Container>
        <section className="section-stack">
          <div className="section-heading">
            <h1>Categories</h1>
            <p>Browse the blog by editorial topic.</p>
          </div>
          <CategoryGrid categories={categories} />
        </section>
      </Container>
    </>
  );
};
